import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {GPLU_WHOLE_LIFE_FIELD_ID, GPLUCoverageCode} from '../../../PlanTemplates/GWL/gpluConstants';
import {
  getAmountValuePath,
  getGPLUBenefitScheduleBlockPropertyPaths,
  getGPLUUnderWritingBlockPropertyPaths,
} from '../PropertyPaths';

export const GPLUUnderWritingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getGPLUUnderWritingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
  const benefitSchPaths = getGPLUBenefitScheduleBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-56c06538-d797-4b59-a210-ad76f6c21ca3'},
      items: [
        {
          key: 'fd412f94-4337-4509-b969-65989a4df7d7',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Underwriting Type"
              id={propertyPaths.underwritingTypeCd}
              value={getQuoteFieldValue(propertyPaths.underwritingTypeCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.underwritingTypeCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUUnderwriting.underwritingTypeCd"
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: '5b815fc9-fc49-49ef-98c5-6e10ec9f56f7',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="GI Amount"
              id={propertyPaths.guaranteedIssueAmount}
              value={getQuoteFieldValue(getAmountValuePath(propertyPaths.guaranteedIssueAmount))}
              onChange={e => {
                const benefitType = getQuoteFieldValue(benefitSchPaths.benefitTypeCd);
                updateQuoteFieldValues([
                  {path: getAmountValuePath(propertyPaths.guaranteedIssueAmount), newValue: e.target.value},
                  {path: getAmountValuePath(propertyPaths.maxUnderWritingLimitAllowance), newValue: e.target.value},
                  {
                    path: getAmountValuePath(propertyPaths.maxDeathBenefitWithPrimaryInsuredTermLife),
                    newValue: e.target.value,
                  },
                  benefitType === 'RangeValues' && {
                    path: getAmountValuePath(benefitSchPaths.benefitMaxAmount),
                    newValue: e.target.value,
                  },
                  benefitType === 'SingleValue' && {
                    path: getAmountValuePath(benefitSchPaths.flatBenefitAmount),
                    newValue: e.target.value,
                  },
                ]);
              }}
              onKeyDown={e => {
                if (['.'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              formFieldId={GPLU_WHOLE_LIFE_FIELD_ID.guaranteedIssueAmount}
              type="number"
              adornment="money"
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'row-627b1d2f-6685-484e-af74-f32da005f8ae'},
      items: [
        {
          key: '0b331e0b-bae1-4d5d-9482-afa3182ace33',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="GI Time Period"
              id={propertyPaths.giTimePeriod}
              value={getQuoteFieldValue(propertyPaths.giTimePeriod)}
              onChange={e => updateQuoteFieldValue(propertyPaths.giTimePeriod, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUUnderwriting.giTimePeriod"
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Underwriting" collapsible withSeparator expanded>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
